<template>
    <el-dialog
            append-to-body
            width="800px"
            :visible.sync="visible"
            title="选择项目"
            @closed="dialogCloseHandler"
            @submit.native.prevent
            custom-class="projects-container">
        <ListLayout>
            <el-form slot="search" :ref="queryFormRef"  inline class="search-form" :model="queryFormData"
                     label-width="70px"
                     @submit.native.prevent>
                <el-form-item label="项目名称" prop="houseName">
                    <el-input type="text" v-model="queryFormData.houseName"
                              placeholder="填写项目名称进行搜索"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="queryHandler">查询</el-button>
                    <el-button type="info" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>

            <el-table :ref="tableRef" :data="page.list" style="height: 400px;"  @select="handleSelection"
                      @select-all="handleSelection">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column type="index" width="50px"></el-table-column>
                <el-table-column label="项目名称" show-overflow-tooltip prop="houseName"></el-table-column>
            </el-table>
        </ListLayout>

        <div slot="footer" class="footer-wrap clearFloat">
            <div style="display: flex;flex-direction: row;justify-content: space-between">
                <el-pagination slot="page" background layout="total, prev, pager, next" :total="page.total"
                               :page-size="page.pageSize"
                               style="text-align: left"
                               :current-page.sync="page.pageNum"
                               @current-change="pageNoToggleHandler"
                               @size-change="pageSizeToggleHandler"></el-pagination>
                <div >
                    <span>已选择<strong>{{selectionNums || parentParam.precincts && parentParam.precincts.length}}</strong>个题目</span>
                    <el-button class="button-wide" type="danger" @click="addParam">添加</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default JBoot({
        props: {},

        data() {
            return {
                moduleName: 'community',
                listMethod: 'queryByPage',
                tableRef: 'pageTableRef',
                resourceList: [],
                selectionRowMap: {},
                visible: false
            }
        },

        computed: {
            selectionNums() {
                return Object.keys(this.selectionRowMap).reduce((result, key) => {
                    return result + (this.selectionRowMap[key] || []).length;
                }, 0);
            },

            submitParams() {
                return Object.keys(this.selectionRowMap).reduce((result, key) => {
                    return result.concat(this.selectionRowMap[key] || []);
                }, []);
            }
        },


        methods: {

            __listInit() {
            },
            __formInit() {
            },

            addParam() {
                if (this.submitParams.length == 0) {
                    this.$warn('请勾选要添加的题目');
                } else {
                    this.$emit("submitParam", {
                        "submitParams": this.submitParams,
                        "selectionRowMap": this.selectionRowMap
                    });
                    this.selectionRowMap = {};
                    this.dialogCloseHandler();
                }
            },

            beforeInit() {
                this.$set(this, 'selectionRowMap', {});
            },

            afterInitPageInfo() {
                this.$nextTick(function () {
                    let tableInstance = this.$getRef(this.tableRef),
                        selectionRows = this.selectionRowMap[this.page.pageNum] || [];
                    if (tableInstance && selectionRows.length > 0) {
                        selectionRows.forEach(item => {
                            this.page.list.filter(ni => ni.id === item.id).forEach(ni => {
                                tableInstance.toggleRowSelection(ni, true);
                            });
                        });
                    } else if (tableInstance && this.parentParam.precincts && this.parentParam.precincts.length > 0) {
                            this.parentParam.precincts.forEach(item => {
                                this.page.list.filter(ni => ni.houseID === item).forEach(ni => {
                                    tableInstance.toggleRowSelection(ni, true);
                                });
                            });
                            this.handleSelection(this.page.list);
                            this.$set(this.parentParam, "precincts", []);
                        
                    }
                    // && this.parentParam.projects.length > 0
                });
            },

            handleSelection(selectionRows) {
                this.$set(this.selectionRowMap, this.page.pageNum, [].concat(selectionRows));
            },

            getQueryParam() {
                return {
                    "houseName:LIKE": this.queryFormData.houseName == undefined ? undefined : this.queryFormData.houseName,
                }
            },

            initPageInfo(response) {
                response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.$set(this, 'page', {
                    list: response.records || [],
                    pageNum: response.current || 1,
                    pageSize: response.size || 10,
                    total: response.total || 0
                })
            },

            show(params) {
                this.parentParam = params || {};
                this.title = this.parentParam.title;
                this.readonly = this.parentParam.readonly;
                this.visible = true;
                this.id = this.parentParam.id;
                this.$set(this,'queryFormData',{});
                this.selectionRowMap = this.parentParam.selectionRowMap
                this.$nextTick(function () {
                    this.queryHandler();
                });
            },

        },

        watch: {}
    }).form().list('pager').build();
</script>

<style lang="scss">
    .projects-container {
        & > .el-dialog__body {


            height: 400px;
            & > .el-table {
                border: 1px solid #efefef !important;
                border-right: none !important;
                height: 400px;
                /*height: calc(100% - 47px - 15px) !important;*/
            }
        }

        & > .el-dialog__footer {
            & > .footer-wrap {
                & > .el-pagination {
                    float: left;

                    & button {
                        padding: 0 !important;
                    }
                }

                & > .right-wrap {
                    & > span {
                        font-size: 13px;
                        margin-right: 5px;
                        color: #606266;

                        & > strong {
                            color: #333333;
                            margin: 0 2px;
                        }
                    }
                }
            }
        }
    }
</



// WEBPACK FOOTER //
// src/components/precinctSelect.vue